import React from 'react';
import { ReactComponent as KeywordNotFoundIcon } from '@assets/results_not_found_icon.svg';
import { noDataMessage } from '@common/ui-constants';
import PropTypes from 'prop-types';

const NoResultsFound = (props) => {
  return (
    <div className={`flex flex-col justify-center items-center ${props.className}`}>
      <div className=" mt-4 mb-2">
        <KeywordNotFoundIcon />
      </div>
      <div className="fontPoppinsMediumLg rs-blue">{noDataMessage.noResultFound}</div>
    </div>
  );
};

NoResultsFound.propTypes = {
  className: PropTypes.string,
};

export default NoResultsFound;
